<template>
  <div id="tipos-anexo">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres
          titulo="Tipos de Anexo"
          :botoes="botoesHeader"
          breakpoint="xl"
        />
      </template>
      <b-card-body>
        <CardFiltrosBusca>
          <b-form @submit.prevent="listar" @reset.prevent="limparFiltros">
            <b-row>
              <b-col cols="12" sm="6" lg="4">
                <default-form-validation-provider label="Descrição" rules="">
                  <b-form-input
                    v-model="filtros.filtroDescricao"
                    size="sm"
                    placeholder="Filtre por descrição"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" sm="6" lg="4">
                <default-form-validation-provider label="Grupo" rules="">
                  <b-form-select
                    v-model="filtros.filtroGrupo"
                    size="sm"
                    :options="gruposSelect"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" sm="6" lg="4">
                <default-form-validation-provider label="Obrigatório" rules="">
                  <b-form-select
                    v-model="filtros.filtroObrigatorio"
                    size="sm"
                    :options="obrigatorioSelect"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" xl="6">
                <default-form-validation-provider
                  label="Tipo do Edital"
                  rules=""
                >
                  <b-form-checkbox-group
                    v-model="filtros.filtroTipoEdital"
                    :options="tiposEditalSelect"
                    buttons
                    button-variant="outline-secondary"
                    size="sm"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="0" xl="6" />
              <b-col cols="6" lg="3" offset-lg="3">
                <b-button
                  type="reset"
                  size="sm"
                  variant="outline-secondary"
                  block
                >
                  <font-awesome-icon icon="redo" class="mr-2" />
                  Limpar
                </b-button>
              </b-col>
              <b-col cols="6" lg="3">
                <b-button type="submit" size="sm" :disabled="tableBusy" block>
                  <font-awesome-icon icon="search" class="mr-2" />
                  Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </CardFiltrosBusca>

        <b-table
          id="tiposAnexoTable"
          :fields="fields"
          :items="items"
          :busy="tableBusy"
          hover
          no-border-collapse
          striped
          stacked="xl"
          show-empty
        >
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>

          <template v-slot:cell(TpGrupoAnexo)="row">
            {{ formatGrupo(row.item.TpGrupoAnexo) }}
          </template>
          <template v-slot:cell(vigencia)="row">
            {{
              formatVigencia(row.item.DtInicioVigencia, row.item.DtFimVigencia)
            }}
          </template>
          <template v-slot:cell(FlObrigatorio)="row">
            {{ row.item.FlObrigatorio ? "Sim" : "Não" }}
          </template>
          <template v-slot:cell(FlPermiteMultiplos)="row">
            {{ row.item.FlPermiteMultiplos ? "Sim" : "Não" }}
          </template>

          <template v-slot:cell(actions)="row">
            <b-dropdown class="d-md-none" right no-caret>
              <template #button-content>
                <font-awesome-icon icon="bars" />
              </template>
              <b-dropdown-item @click="openModal(row.item)">
                <font-awesome-icon icon="edit" />
                <span class="pl-2">Editar</span>
              </b-dropdown-item>
              <b-dropdown-item @click="alertaRemove(row.item)">
                <font-awesome-icon icon="trash" />
                <span class="pl-2">Excluir</span>
              </b-dropdown-item>
            </b-dropdown>
            <div
              class="actions-icons lgvert d-none d-md-flex justify-content-center"
            >
              <b-link class="text-dark" @click="openModal(row.item)">
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
              <b-link class="text-dark" @click="alertaRemove(row.item)">
                <font-awesome-icon icon="trash" />
                <div style="font-size: 12px">Excluir</div>
              </b-link>
            </div>
          </template>
        </b-table>

        <table-pagination
          v-if="totalRows"
          :total-rows="totalRows"
          :per-page="pageSize"
          @pageChange="pageChange"
        />
      </b-card-body>
    </b-card>

    <ModalTipoAnexo
      v-if="modalAberto"
      :item="selectedItem"
      @close="modalAberto = false"
      @salvo="listar"
    />
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { TableField } from "@/types/table-field";
import { BotaoSagres } from "@/types/botao-sagres";
import { SelectValue } from "@/types/select-value";
import { TipoAnexo } from "@/types/atos-pessoal/concursos/tipo-anexo";
import { FiltrosTipoAnexo } from "@/types/atos-pessoal/concursos/filtros-tipo-anexo";
import { Component, Vue } from "vue-property-decorator";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import concursoService from "@/services/atos-pessoal/concursoService";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import ModalTipoAnexo from "@/components/atos-pessoal/concursos/ModalTipoAnexo.vue";
import { fieldsTiposAnexo } from "@/types/atos-pessoal/concursos/fields-tipos-anexo";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";

const GRUPOS: Record<string, string> = {
  CAD: "Cadastramento",
  CAN: "Cancelamento",
  PUB: "Publicidade",
  HML: "Homologação",
  PRO: "Prorrogação",
};

const CompProps = Vue.extend({
  name: "TiposAnexo",
  components: {
    HeaderSagres,
    TablePagination,
    CardFiltrosBusca,
    ModalTipoAnexo,
    DefaultFormValidationProvider,
  },
});

@Component
export default class TiposAnexo extends mixins(UtilsTS, CompProps) {
  pageSize = 10;
  totalRows = 0;
  currentPage = 1;
  tableBusy = false;
  modalAberto = false;
  selectedItem: TipoAnexo | null = null;

  filtros = new FiltrosTipoAnexo();

  items: TipoAnexo[] = [];
  fields: TableField[] = fieldsTiposAnexo;

  gruposSelect: SelectValue[] = [
    { value: null, text: "Todos os grupos" },
    { value: "CAD", text: "Cadastro" },
    { value: "HML", text: "Homologação" },
    { value: "PUB", text: "Publicidade" },
    { value: "PRO", text: "Prorrogação" },
    { value: "CAN", text: "Cancelamento" },
  ];

  obrigatorioSelect: SelectValue[] = [
    { value: null, text: "Todos" },
    { value: "true", text: "Sim" },
    { value: "false", text: "Não" },
  ];

  tiposEditalSelect: SelectValue[] = [
    { value: "CON", text: "Concurso" },
    { value: "PSP", text: "Processo Seletivo Público" },
    { value: "PSS", text: "Processo Seletivo Simplificado" },
  ];

  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: "plus",
      texto: "Adicionar Tipo",
      acao: () => this.openModal(),
    },
  ];

  async mounted(): Promise<void> {
    await this.listar();
  }

  async listar(): Promise<void> {
    try {
      this.tableBusy = true;
      const response = await concursoService.listarTiposAnexo(
        this.currentPage,
        this.filtros
      );
      if (!response) {
        this.$toast.error("Erro ao obter a lista de Tipos de Anexo");
        return;
      }
      this.items = response.tiposAnexo ?? [];
      this.totalRows = response.totalRows ?? 0;
      this.currentPage = response.page ?? 1;
    } catch (error: any) {
      this.tratarError(error);
      this.items = [];
      this.totalRows = 0;
    } finally {
      this.tableBusy = false;
    }
  }

  openModal(item?: TipoAnexo): void {
    this.selectedItem = item ?? null;
    this.modalAberto = true;
  }

  alertaRemove(item: TipoAnexo): void {
    this.$bvModal
      .msgBoxConfirm(`Deseja remover o tipo de anexo "${item.DsTipoAnexo}"?`, {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        okVariant: "secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar",
        title: "Excluir Tipo de Anexo",
      })
      .then((value) => {
        if (value) this.remover(item);
      })
      .catch((err) => console.error(err));
  }

  async remover(item: TipoAnexo): Promise<void> {
    try {
      this.tableBusy = true;
      await concursoService.removerTipoAnexo(item.IdTipoAnexo);
      this.$toast.success("Tipo de Anexo removido com sucesso");
      await this.listar();
    } catch (error: any) {
      this.tratarError(error);
    } finally {
      this.tableBusy = false;
    }
  }

  async pageChange(value: number): Promise<void> {
    this.currentPage = value;
    await this.listar();
  }

  limparFiltros(): void {
    this.filtros.limpar();
    this.currentPage = 1;
    this.listar();
  }

  formatGrupo(code: string): string {
    return GRUPOS[code] ?? code;
  }

  formatVigencia(inicio: string | null, fim: string | null): string {
    const fmt = (d: string | null) =>
      d ? d.split("T")[0].split("-").reverse().join("/") : "-";
    return `${fmt(inicio)} - ${fmt(fim)}`;
  }
}
</script>
